import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    updateWorkSheet,
    clear_work_sheet,
    UPDATE_WORK_SHEET,
    getAllWorkSheets,
} from "../../../redux/work_sheets";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import {
    createWorkProcess, 
    CREATE_WORK_PROCESS,
    clear_work_process,
} from '../../../redux/work_process';

const UpdateWorkSheet = () => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);
    const _get_all_user_types = useSelector((state) => state.user_types_module._get_all_user_types);
    const _get_all_periodicities = useSelector((state) => state.periodicities_module._get_all_periodicities);
    const _create_work_process = useSelector((state) => state.work_process_module._create_work_process);

    const [userTypes, setUserTypes] = useState([]);
    const [periodicities, setPeriodicities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [process, setProcess] = useState('');

    useEffect(() => {
        if (_get_all_user_types.data.datos) {
            setUserTypes(_get_all_user_types.data.datos);
        }
    }, [_get_all_user_types]);

    useEffect(() => {
        if (_get_all_periodicities.data.datos) {
            setPeriodicities(_get_all_periodicities.data.datos);
        }
    }, [_get_all_periodicities]);

    const _update_work_sheet = useSelector((state) => state.work_sheets_module._update_work_sheet);

    const [form, setForm] = useState({
        nombre: "",
        id_tipo_usuario: 0,
        tipo_usuario: "",
        id_periodicidad: 0,
        periodicidad: "",
        activo: true,
        procesos: [],
    });

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            let item = _get_all_work_sheets.data.datos.filter((x) => x.id === parseInt(id))
            if (item.length > 0) {
                setForm({
                    nombre: item[0].nombre,
                    id_tipo_usuario: item[0].id_tipo_usuario,
                    tipo_usuario: item[0].tipo_usuario,
                    id_periodicidad: item[0].id_periodicidad,
                    periodicidad: item[0].periodicidad,
                    activo: item[0].activo,
                    procesos: item[0].procesos
                })
            }
        }
    }, [_get_all_work_sheets, id]);

    useEffect(() => {
        if (_update_work_sheet.status === 200) {
            dispatch(clear_work_sheet(UPDATE_WORK_SHEET));
            history.push("/hojas-trabajos");
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
        } else if (_update_work_sheet.status !== 0) {
            dispatch(clear_work_sheet(UPDATE_WORK_SHEET));
            toast.error(_update_work_sheet.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_work_sheet, dispatch, history, token]);

    
    const handleChange = (e) => {
        if (e.target.name === "id_tipo_usuario" || e.target.name === "id_periodicidad") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_periodicidad === 0) {
            toast.error("Debe seleccionar la periodicidad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_usuario === 0) {
            toast.error("Debe seleccionar el tipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateWorkSheet(token, id, form));
    };

    useEffect(() => {
        if (_create_work_process.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_process(CREATE_WORK_PROCESS));
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
            setModal(false);
            /* history.push(`/hoja-trabajo/detalle/${_create_work_process.data.datos.id}`); */
        } else if (_create_work_process.status !== 0) {
            dispatch(clear_work_process(CREATE_WORK_PROCESS));
            toast.error(_create_work_process.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_work_process, dispatch, history, token]);

    const handleSubmitProcess = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (process === '') {
            toast.error("Debe ingresar un proceso", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createWorkProcess(token, {nombre: process, id_hoja_trabajo: id}));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hojas de trabajos"
                            items={[
                                {label: "Detalles", link: "/hojas-trabajos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar hoja de trabajo</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Periodicidad</label>
                                                <SelectInput
                                                    id="id_periodicidad"
                                                    label="periodicidad"
                                                    name="id_periodicidad"
                                                    value={form.id_periodicidad}
                                                    select={form.periodicidad}
                                                    onChange={handleChange}
                                                    options={periodicities ? periodicities.map((item) => ({
                                                        name: item.descripcion,
                                                        id: item.id,
                                                    })) : []}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo</label>
                                                <SelectInput
                                                    label="tipo"
                                                    name="id_tipo_usuario"
                                                    value={form.id_tipo_usuario}
                                                    select={form.tipo_usuario}
                                                    onChange={handleChange}
                                                    options={userTypes ? userTypes.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    })) : []}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Procesos</p>
                                            <p className="text-body">Sección para asignar los procesos que conforman la
                                                hoja de trabajo</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1"
                                                    onChange={() => {
                                                        setProcess('');
                                                        setModal(true);
                                                    }}/>
                                        </div>
                                        {form.procesos.length > 0 && (
                                            form.procesos.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                                <strong
                                                                    className="texto_16">Subprocesos: {item.subprocesos}</strong><br/>
                                                                <span
                                                                    className="texto_14">{item.activo ? 'Activo' : 'Inactivo'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="text-right mt-2" style={{width: '10%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/edit.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    history.push(`/proceso-trabajo/detalle/${id}/${item.id}`);
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Link to="/hojas-trabajos"
                                              className="btn btn-outline-dark magin_button button_responsible">
                                            Cancelar
                                        </Link>
                                        <Button type="submit" text="Guardar" classes="button_responsible" theme="calendar"
                                                disabled={isLoading}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitProcess}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar proceso</h5>
                        <div className="form-group">
                            <Input
                                name="proceso"
                                label="proceso"
                                value={process}
                                onChange={(e) => {setProcess(e.target.value)}}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateWorkSheet;
